import React, { FC } from 'react';
import { Text } from '../../../../../components/common';
import { useMMGRSettings } from '../../../../../utils/hoc/withMMGRSettings';

interface Props {
  className?: string;
}

export const NavItemTitle: FC<Props> = (props) => {
  const {
    mmgrSettings: { isUIAlignmentsEnabled },
  } = useMMGRSettings();
  return (
    <Text
      weight="bold"
      size={isUIAlignmentsEnabled ? "small" : "medium"}
      tagName="div"
      className={props.className}
      {...props}
    />
  );
};
